
import "swiper/css";
import "swiper/css/navigation";
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import TopBannerForm from './TopBannerForm';
import HomeAllInclusive from './HomeAllInclusive';
import HomeFlight from './HomeFlight';
import HomeCruisePackageDeals from './HomeCruisePackageDeals';
import HomeRelaxingBeach from './HomeRelaxingBeach';
import HomeWantSeeWorld from './HomeWantSeeWorld';
import HomeBlogSection from './HomeBlogSection';
import { Helmet } from 'react-helmet-async';
import TravelModal from './TravelModal';
import HomeSportsTickets from './HomeSports';
import hotelherobg from '../../../assets/images/hotel-hero-bg.png'
import smallthum1 from '../../../assets/images/small-thum-1.jpg'
import smallthum2 from '../../../assets/images/small-thum-2.jpg'
import beachview from '../../../assets/images/beach-view.jpg'
import travelimage from '../../../assets/images/travel-image.jpg'
import favoritebg from '../../../assets/images/Favorite-bg.jpg'
import LeftImg from '../../../assets/images/LeftImg.jpg'
import centerImg from '../../../assets/images/centerImg.jpg'
import RightImg from '../../../assets/images/RightImg.jpg'
import Adventurebg from '../../../assets/images/Adventure-bg.jpg'

export default function Home() {
    const place = useSelector((state) => state.place);
    const pageTitle = place
        ? `${place} Hotels | Best Deals, Attractions & Tours`
        : `Hotels & Travel Deals | Explore Top Destinations`;

    const pageDescription = place
        ? `Explore top hotels, attractions, tours, wineries, fine dining and travel deals in ${place}. Discover traveler favorites worth booking.`
        : `Explore top hotels, tours, wineries, fine dining and unforgettable travel experiences. Discover traveler favorites worth booking.`;


    const modalHide = () => {
        const modalEl = document.getElementById("TravelModal");
        const modalInstance = window.bootstrap?.Modal.getInstance(modalEl);
        modalInstance?.hide();
    };

    return (
        <>
            <Helmet>
                <title>{pageTitle}</title>

                <meta name="description" content={pageDescription} />

                {/* Open Graph for social preview */}
                <meta property="og:title" content={pageTitle} />
                <meta property="og:description" content={pageDescription} />
                <meta property="og:type" content="website" />
                <meta property="og:image" content={hotelherobg} />

                {/* Optional: Keywords */}
                <meta
                    name="keywords"
                    content="hotels, tours, travel deals, attractions, fine dining, wineries, best places to visit"
                />
            </Helmet>

            <TopBannerForm />

            <section className="section-equal-padding bg-light-gray">
                <div className="container">
                    <div className="row">
                        <div className="col-12 col-sm-12 col-md-12 col-lg-9 mx-auto">
                            <div className="img-top-head text-center" uk-scrollspy="cls: uk-animation-slide-bottom; delay: 400; repeat: false">
                                <h2 className="mb-0 mb-md-4">Make your move and discover <span className="sub-thumb-head"><img className="small-img1" src={smallthum1} alt="Hero image" /></span> the World <span className="sub-thumb-head"><img className="small-img2" src={smallthum2} alt="Hero image" /></span> that’s waiting for you.</h2>
                                <p>Traveling changes you. You see new places, meet new people, and become a new version of yourself.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="section-equal-padding bg-white">
                <div className="container">
                    <div className="vacation-plan-box" style={{ backgroundImage: `url(${beachview})`, backgroundRepeat: 'no-repeat', backgroundSize: 'cover' }} uk-scrollspy="cls: uk-animation-slide-bottom; delay: 400; repeat: false">
                        <div className="vacation-plan-content text-center">
                            <h2>Planning a vacation shouldn't be stressful.</h2>
                            <p>Fast. Simple. Designed around your travel style.</p>
                        </div>
                        <div className="mt-4 text-center">
                            <button className="white-btn d-inline-flex align-items-center gap-2" data-bs-toggle="modal"
                                data-bs-target="#TravelModal">Plan Smarter! Start Now <i
                                    className="fa-solid fa-arrow-right"></i></button>
                        </div>
                    </div>
                </div>
            </section>


            <section className="section-equal-padding bg-white pt-0">
                <div className="container">
                    <div className="row">
                        <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                            <div className="travel-figure pe-0 pe-lg-4 h-100" uk-scrollspy="cls: uk-animation-slide-bottom; delay: 400; repeat: false">
                                <img src={travelimage} />
                            </div>
                        </div>
                        <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                            <div className="section-top-heading mb-3 mb-md-5  pt-3" uk-scrollspy="cls: uk-animation-slide-bottom; delay: 400; repeat: false">
                                <h2 className="mb-2">Traveling makes you rich in stories, experiences, and memories</h2>
                                <p>Traveling changes you. You see new places, meet new people, and become a new version of yourself.</p>
                            </div>

                            <div className="traveling-stat">
                                <div className="stat-block d-flex justify-content-between align-items-center" uk-scrollspy="cls: uk-animation-slide-bottom; delay: 400; repeat: false">
                                    <div className="stat">
                                        <span className="counting" data-count="95"></span>95%
                                    </div>
                                    <div className="stat-caption">
                                        <p>Customer Satisfaction</p>
                                    </div>
                                </div>
                                <div className="stat-block d-flex justify-content-between align-items-center">
                                    <div className="stat">
                                        <span className="counting" data-count="80"></span>80+
                                    </div>
                                    <div className="stat-caption">
                                        <p>Popular Destinations</p>
                                    </div>
                                </div>
                                <div className="stat-block d-flex justify-content-between align-items-center">
                                    <div className="stat">
                                        <span className="counting" data-count="95"></span>95%
                                    </div>
                                    <div className="stat-caption">
                                        <p>Experienced Guide</p>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>

            <HomeSportsTickets />

            {/* ---------------- ALL-INCLUSIVE RESORTS SECTION ---------------- */}
            <HomeAllInclusive />

            <section className="section-equal-padding favorite-section"
                style={{
                    backgroundImage: `url(${favoritebg})`
                }}
                uk-scrollspy="cls: uk-animation-slide-bottom; delay: 400; repeat: false">
                <div className="container-fluid">
                    <div className="row">
                       <div className="col-12 col-sm-12 col-md-12 col-lg-8 col-xxl-6">
                        <div className="favorite-block" uk-scrollspy="cls: uk-animation-slide-bottom; delay: 400; repeat: false">
                        <h2 className="mb-3">Traveler Favorites: <br />Deals Worth Booking</h2>
                        <p>Discover the most loved travel deals, handpicked by explorers like you. These top-rated escapes combine unbeatable value with unforgettable experiences from stunning beach resorts to thrilling city adventures. </p>
                        <Link to={place ? '/deals/:sub' : '/deals'} className="white-btn mt-3">View Deals</Link>
                    </div>
                       </div>
                    </div>
                </div>
            </section>

            {/* ---------------- Flight SECTION ---------------- */}
            <HomeFlight />

            {/* ---------------- Cruise Package Deals SECTION ---------------- */}
            <HomeCruisePackageDeals />

            <section className="section-equal-padding bg-black">
                <div className="container">
                    <div className="row">
                        <div className="col-12 col-sm-12 col-md-12 col-lg-10 mx-auto">
                            <div className="section-top-heading mb-2 text-center" uk-scrollspy="cls: uk-animation-slide-bottom; delay: 400; repeat: false">
                                <h2 className="text-white">Whatever You’re Into, We’ve Got the Perfect Escape</h2>
                            </div>
                        </div>
                        <div className="col-12 col-sm-12 col-md-12 col-lg-7 mx-auto">
                            <div className="section-top-heading mb-3 mb-md-5 text-center" uk-scrollspy="cls: uk-animation-slide-bottom; delay: 400; repeat: false">
                                <p className="text-white">Start your next adventure with ease! Explore curated travel plans,save your favourite destinations, and make every trip unforgettable.</p>
                            </div>
                        </div>
                    </div>

                    <div className="perfect-img-section" uk-scrollspy="cls: uk-animation-slide-bottom; delay: 400; repeat: false">
                        <figure className="figure-left">
                            <img src={LeftImg} className="img-fluid" />
                        </figure>
                        <figure className="figure-center">
                            <img src={centerImg} className="img-fluid" />
                        </figure>
                        <figure className="figure-right">
                            <img src={RightImg} className="img-fluid" />
                        </figure>
                    </div>

                    <div className="mt-4 text-center" uk-scrollspy="cls: uk-animation-slide-bottom; delay: 400; repeat: false">
                        <a href="" className="white-btn">Explore More</a>
                    </div>

                </div>
            </section>

            {/* ---------------- Relaxing Beach Gateways SECTION ---------------- */}

            <HomeRelaxingBeach />

            {/* ---------------- Want to see the World SECTION ---------------- */}
            <HomeWantSeeWorld />

            <section className="section-equal-padding adventure-section" style={{ backgroundImage: `url(${Adventurebg})`, backgroundRepeat: 'no-repeat', backgroundSize: 'cover' }}>
                <div className="container">
                    <div className="adventure-block text-center" uk-scrollspy="cls: uk-animation-slide-bottom; delay: 400; repeat: false">
                        <h2>Get Ready for an Adventure!</h2>
                        <p>Start your journey with us, where we guarantee the lowest prices. Book top hotel rooms for $20-$30 less per night and save $25-$50 on flights compared to other travel sites. Explore our site, grab great deals, and let the thrill of savings fuel your dream getaway! </p>
                        <div className="mt-4 text-center">
                            <a href="" className="white-btn">Explore More</a>
                        </div>
                    </div>
                </div>
            </section>

            {/* ---------------- Want to see the World SECTION ---------------- */}
            <HomeBlogSection />

            <div className="modal fade planTravelmodal" id="TravelModal" tabIndex="-1" aria-labelledby="exampleModalLabel"
                aria-hidden="true">
                <TravelModal modalHide={modalHide} />
            </div>

        </>

    )
}
